/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L7_NInputs */

const en_mk_sec_pg_l7_n = /** @type {(inputs: Mk_Sec_Pg_L7_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not built. If this is a hard requirement for your organisation, this product does not fit yet.`)
};

const id_mk_sec_pg_l7_n = /** @type {(inputs: Mk_Sec_Pg_L7_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum dibangun. Kalau ini syarat mutlak bagi organisasi Anda, produk ini belum cocok hari ini.`)
};

/**
* | output |
* | --- |
* | "Not built. If this is a hard requirement for your organisation, this product does not fit yet." |
*
* @param {Mk_Sec_Pg_L7_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l7_n = /** @type {((inputs?: Mk_Sec_Pg_L7_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L7_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l7_n(inputs)
	return en_mk_sec_pg_l7_n(inputs)
});